import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { AUDIENCE } from './salesData';

/** Para quién es KETO 4P. */
export function AudienceSection() {
  return <section id="para-quien" className="w-full border-b border-line bg-carbon" data-id="element-21" data-mp="s0bdho1sztwx">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-22" data-mp="wzfmadktfpmq">
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14" data-id="element-23" data-mp="wxl9xnnm15u9">
          <div data-id="element-24" data-mp="3viw9hvnikp9k">
            <SectionTag data-id="element-25" data-mp="3vf8f6ua8vyts">Para quién es</SectionTag>
            <h2 className="mt-4 font-condensed text-[2.1rem] uppercase leading-[0.95] text-bone sm:text-[3.2rem]" data-id="element-26" data-mp="4a8ojgt6r42j">
              Es para vos si…
            </h2>
          </div>

          <ul className="space-y-3" data-id="element-27" data-mp="e0js328yjb8w">
            {AUDIENCE.map(item => <li key={item} className="flex items-start gap-3.5 rounded-xl border border-line bg-ink/60 px-5 py-4 text-[0.97rem] leading-snug text-bone/85" data-id="element-28" data-mp="e2wg9x5b6hue">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-29" data-mp="3hnk50wjk3kfg" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}